import React from 'react';
import classnames from 'classnames';
import { node, func, bool } from 'prop-types';
import Cell, { TH } from './cell';
import { Checkbox } from '../form';
import tableShape from './tableShape';

const Head = ({
  className,
  checked,
  onSelectionChange,
  children,
  selectable,
  expandable,
  table,
  ...props
}) => {
  const checkboxCell = (
    <Cell className={'mdl-data-table__cell--checkbox'}>
      <Checkbox checked={checked} onChange={onSelectionChange} />
    </Cell>
  );

  const cells = React.Children.map(
    React.Children
      .toArray(children)
      .filter(child => child && child.type === Cell),
    (cell, index) => {
      const columnId = cell.props.columnId || index;
      table.updateColumn(columnId, cell.props);

      return React.cloneElement(cell, {
        tag: TH,
      });
    },
  )
;

  return (
    <tr
      className={classnames(
        'mdc-data-table-head',
        className,
      )}
      {...props}
    >
      {expandable && <Cell tag={TH} className="mdl-data-table__cell--collapse-btn" />}
      {selectable && checkboxCell}
      {cells}
    </tr>
  );
};

Head.propTypes = {
  children: node.isRequired,
  onSelectionChange: func,
  selectable: bool,
  expandable: bool,
  checked: bool,
  table: tableShape,
};

Head.defaultProps = {
  expandable: false,
  selectable: false,
  checked: false,
  onClick: null,
  onSelectionChange: undefined,
  table: undefined,
};

export default Head;
